export default __webpack_public_path__ + "images/777f19086d57c5de5a008b3ea3b0d2bc-6_mobile_659x494.jpg";